import { deflate } from 'pako'

// Utility function to compress the betslip data
const compressData = (data: any, isSingle: boolean) => {
  try {
    // Convert data to compressed binary
    const compressedData = isSingle
      ? {
          cid: data.conditionId, // conditionId
          o: data.outcomeId, // outcomeId
          e: data.isExpressForbidden, // isExpressForbidden
          tx: data.transactionHash, // transactionHash
          c: data.chainId, // chainId
          od: data.odds, // odds
          s: data.selectionName, // selectionName
          ga: data.game, // game
          ma: data.marketName, // marketName
        }
      : data.map((bet: any) => ({
          cid: bet.conditionId, // conditionId
          o: bet.outcomeId, // outcomeId
          e: bet.isExpressForbidden, // isExpressForbidden
          tx: bet.transactionHash, // transactionHash
          c: bet.chainId, // chainId
          od: bet.odds, // odds
          s: bet.selectionName, // selectionName
          ga: bet.game, // game
          ma: bet.marketName, // marketName
        }))

    // Compress using GZIP
    const compressed = deflate(JSON.stringify(compressedData))

    // Convert to URL-safe base64
    return Buffer.from(compressed)
      .toString('base64')
      .replace(/\+/g, '-')
      .replace(/\//g, '_')
      .replace(/=+$/, '')
  } catch (error) {
    console.error('Compression error:', error)
    throw error
  }
}

export default compressData
